export default (suggestions, alreadyChosen) => {
    var newSuggestions = [];
    suggestions.forEach(function (suggestion) {
        var allowedSugg = true;
        //check if already chosen from suggestions
        alreadyChosen.forEach(function (chosen) {
            if (chosen.id===suggestion.id || chosen===suggestion.id) allowedSugg = false;
            if (chosen.id===suggestion.productId || chosen===suggestion.productId) allowedSugg = false;
            if (chosen.productId===suggestion.productId || chosen===suggestion.productId) allowedSugg = false;
        });
        if (allowedSugg) newSuggestions.push(suggestion);
    })
    return newSuggestions;
}


// WEBPACK FOOTER //
// ./src/App/Util/stripSuggestions.js